/* Kirane, le trio (v5 : galerie de looks, fiche look, canapé interactif, module fiche produit).
   v5 : les housses du canapé sont des photos détourées, posées à leur vraie taille en cm. Vanilla, no deps. */
(function () {
  'use strict';

  const cfg = window.trioConfig || {};
  const money = (cents) => {
    const fmt = cfg.moneyFormat || '{{amount}} €';
    const v = cents / 100;
    const comma = v.toFixed(2).replace('.', ',');
    const noDec = Math.round(v).toString();
    const smart = Number.isInteger(v) ? noDec : comma;
    return fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, smart)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/, smart)
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/, smart)
      .replace(/\{\{\s*amount\s*\}\}/, Number.isInteger(v) ? noDec : v.toFixed(2));
  };
  const t = (key, fallback) => (cfg.strings && cfg.strings[key]) || fallback;
  const fill = (str, vars) => Object.keys(vars || {}).reduce((s, k) => s.split('{' + k + '}').join(vars[k]), str);
  const img = (src, w) => {
    if (!src) return '';
    const clean = src.replace(/(&|\?)width=\d+/, '');
    return clean + (clean.includes('?') ? '&' : '?') + 'width=' + (w || 480);
  };
  /* vignette sur le canapé : la photo choisie dans trio-swatches. Le cadrage se fait en SVG (voir CROP). */
  const swatchFor = (p) => {
    const want = cfg.swatches && cfg.swatches[p.handle];
    let src = p.image;
    if (want && p.images && p.images.length) {
      const hit = p.images.find((u) => u.indexOf(want) !== -1);
      if (hit) src = hit;
    }
    return src ? src.split('?')[0] + '?width=700' : '';
  };
  const sizeKey = (str) => {
    if (!str) return null;
    const s = String(str).toLowerCase();
    if (/rond/.test(s)) return 'rond';
    const m = s.match(/(\d{2,3})\s*(?:cm)?\s*x\s*(\d{2,3})/);
    return m ? m[1] + 'x' + m[2] : null;
  };
  const sizeLabel = (key) => (!key ? '' : key === 'rond' ? t('round', 'rond') : key.replace('x', ' × ') + ' cm');
  const optLabel = (title) => { const k = sizeKey(title); return k ? sizeLabel(k) : title.replace(/^Velours\s+/i, ''); };
  const shortTitle = (title) => title.replace(/^Housses? de Coussins?\s*(Rond\s*)?(-\s*)?/i, (m, r) => (r ? 'rond · ' : '')).replace(/\s*-\s*\d{2,3}\s*x\s*\d{2,3}\s*cm$/i, '').replace(/\s*-\s*XL.*$/i, ' XL').trim();
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* la couleur, c'est la base : on la lit sur les tags couleur-* */
  const colourOf = (p) => {
    const tag = (p.tags || []).map((x) => String(x).toLowerCase()).find((x) => x.indexOf('couleur-') === 0 && x !== 'couleur-a-verifier');
    return tag ? t('filter_' + tag.slice(8), '') : '';
  };

  const normalise = (p) => {
    const variants = (p.variants || []).map((v) => ({
      id: v.id, title: v.title,
      price: typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price,
      available: v.available !== false,
      size: sizeKey(v.title) || sizeKey(p.title)
    }));
    return {
      id: p.id, handle: p.handle, title: p.title,
      short: p.short || shortTitle(p.title),
      url: p.url || (cfg.productsUrl || '/products/') + p.handle,
      image: p.image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '',
      images: (p.images || []).map((i) => (typeof i === 'string' ? i : i && i.src)).filter(Boolean),
      tags: (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map((x) => x.trim())).filter(Boolean),
      hasOptions: variants.length > 1, variants,
      minPrice: Math.min.apply(null, variants.map((v) => v.price))
    };
  };
  const firstAvailable = (p) => p.variants.find((v) => v.available) || p.variants[0];
  /* pas de règle : on propose simplement une taille pas encore utilisée, pour varier */
  const varyVariant = (p, usedSizes) => p.variants.find((v) => v.available && (usedSizes || []).indexOf(v.size) === -1) || firstAvailable(p);
  const insertFor = (key) => {
    const ins = cfg.inserts;
    if (!ins || !key) return null;
    if (key === 'rond') return ins.round;
    if (key === '110x55' || key === '55x110') return ins.xl;
    const alt = key.split('x').reverse().join('x');
    return (ins.square || []).find((v) => { const k = sizeKey(v.size); return k === key || k === alt; }) || null;
  };

  /* verrou de défilement : on compense la barre pour que la page ne saute pas quand un panneau s'ouvre */
  let trioLocks = 0;
  const lockScroll = () => {
    if (++trioLocks > 1) return;
    const bar = window.innerWidth - document.documentElement.clientWidth;
    if (bar > 0) document.body.style.paddingRight = bar + 'px';
    document.body.classList.add('trio-sheet-open');
  };
  const unlockScroll = (all) => {
    trioLocks = all ? 0 : Math.max(0, trioLocks - 1);
    if (trioLocks) return;
    document.body.classList.remove('trio-sheet-open');
    document.body.style.paddingRight = '';
  };

  /* ---- cart ---- */
  const addToCart = (items) => {
    const useDrawer = cfg.cartDrawer && document.getElementById('Cart-Drawer');
    const body = { items };
    if (useDrawer) { body.sections = 'cart-drawer,cart-bubble'; body.sections_url = window.location.pathname; }
    return fetch(cfg.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then((r) => r.json()).then((res) => {
      if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'Erreur');
      /* on referme le trio : sinon le panier s'ouvre derrière le panneau, surtout sur mobile */
      document.querySelectorAll('.trio-sheet.is-open, .trio-lsheet.is-open').forEach((el) => el.classList.remove('is-open'));
      unlockScroll(true);
      if (useDrawer && res.sections) {
        const render = (id, sel, html) => {
          const root = document.getElementById(id); if (!root || !html) return;
          const target = root.querySelector(sel) || root;
          const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
          if (parsed) target.innerHTML = parsed.innerHTML;
        };
        render('Cart-Drawer', '.cart-drawer', res.sections['cart-drawer']);
        render('cart-drawer-toggle', '.thb-item-count', res.sections['cart-bubble']);
        const drawer = document.getElementById('Cart-Drawer');
        if (typeof OverlayManager !== 'undefined') OverlayManager.open(drawer); else drawer.classList.add('active');
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart-drawer:open');
          (res.items || []).forEach((it) => dispatchCustomEvent('cart:item-added', { product: it }));
        }
      } else {
        window.location.href = cfg.cartUrl;
      }
      return res;
    });
  };

  /* ---- prix : deux achetées, la troisième offerte (deux offertes au maximum) ---- */
  const price = (slots) => {
    const covers = [];
    slots.forEach((s, i) => { if (s && s.product) covers.push({ s: s, i: i }); });
    const n = covers.length;
    const mode = cfg.offer || 'none';
    let nFree = 0;
    if (mode === 'third_free') nFree = Math.min(Math.floor(n / 3), 2);
    /* les moins chères sont celles qui sont offertes, comme la remise Shopify */
    const free = covers.slice().sort((a, b) => a.s.variant.price - b.s.variant.price).slice(0, nFree).map((x) => x.i);
    return { n: n, nFree: nFree, free: free, offer: mode !== 'none' };
  };
  /* jamais de total : le prix est sous chaque housse. Ici, seulement l'encouragement. */
  const nudgeLine = (pr) => (pr.offer && pr.n === 2
    ? '<span class="trio-priceline__note">' + esc(t('one_more', 'encore une housse, et la troisième est offerte')) + '</span>'
    : '');
  /* le prix d'une housse : barré quand elle est offerte, intérieur compris quand il est coché */
  const linePrice = (slot, isFree) => {
    const v = slot.variant, ins = insertFor(v.size);
    const on = !!slot.insert && ins && ins.available !== false;
    const insP = on ? ins.price : 0;
    if (isFree) {
      return '<span class="trio-line__price"><s>' + esc(money(v.price)) + '</s>' +
        (insP ? '<b>' + esc(money(insP)) + '</b>' : '<b>' + esc(t('free_short', 'offerte')) + '</b>') + '</span>';
    }
    return '<span class="trio-line__price">' + esc(money(v.price + insP)) + '</span>';
  };

  /* le titre ne répète pas ce qui est déjà écrit juste au-dessus */
  const trimEyebrow = (title, eyebrow) => {
    if (!eyebrow) return title;
    const pre = String(eyebrow).toLowerCase() + ' · ';
    return String(title).toLowerCase().indexOf(pre) === 0 ? title.slice(pre.length) : title;
  };

  /* le total réellement payé : housses non offertes + intérieurs cochés */
  const totalOf = (slots, pr) => {
    let sum = 0;
    (slots || []).forEach((s, i) => {
      if (!s || !s.product || !s.variant) return;
      const ins = insertFor(s.variant.size);
      if (!pr || pr.free.indexOf(i) === -1) sum += s.variant.price;
      if (s.insert && ins && ins.available !== false) sum += ins.price;
    });
    return sum;
  };

  /* ---- une ligne par housse ---- */
  const lineHTML = (slot, opts) => {
    const p = slot.product, v = slot.variant, o = opts || {};
    /* en haut de la ligne : la taille — sauf si les pastilles de taille l'affichent déjà juste dessous */
    const eyebrow = o.eyebrow || (p.hasOptions ? '' : sizeLabel(v.size));
    return '' +
      '<div class="trio-line' + (v.available ? '' : ' is-soldout') + '" data-slot="' + slot.index + '">' +
        '<a class="trio-line__img" href="' + esc(p.url) + '" tabindex="-1"><img src="' + esc(img(p.image, 240)) + '" alt="" loading="lazy" width="96" height="96"></a>' +
        '<div class="trio-line__main">' +
          '<div class="trio-line__top">' +
            '<span class="trio-line__place">' + esc(eyebrow) + '</span>' +
            (o.removable ? '<button type="button" class="trio-line__remove" data-remove aria-label="' + esc(t('remove', 'retirer')) + '">×</button>' : '') +
          '</div>' +
          '<a class="trio-line__title" href="' + esc(p.url) + '">' + esc(trimEyebrow(p.short, eyebrow)) + '</a>' +
          (p.hasOptions
            ? '<div class="trio-seg" role="radiogroup" aria-label="' + esc(t('size', 'taille')) + '">' + p.variants.map((x) => '<button type="button" class="trio-seg__btn' + (x.id === v.id ? ' is-on' : '') + (x.available ? '' : ' is-off') + '" data-variant="' + x.id + '" role="radio" aria-checked="' + (x.id === v.id) + '">' + esc(optLabel(x.title)) + '</button>').join('') + '</div>'
            : '') +
          '<div class="trio-line__pay">' + linePrice(slot, !!o.free) +
          (o.perInsert ? (function () { const ins = insertFor(v.size); const ok = ins && ins.available !== false; const on = slot.insert && ok; return ins ? '<label class="trio-switch trio-switch--small' + (ok ? '' : ' is-disabled') + '"><input type="checkbox" data-insert ' + (on ? 'checked' : '') + ' ' + (ok ? '' : 'disabled') + '><span class="trio-switch__track"><span class="trio-switch__knob"></span></span><span class="trio-switch__label">' + esc(t('with_insert', 'avec son intérieur')) + (on ? '' : '<em>+ ' + esc(money(ins.price)) + '</em>') + '</span></label>' : ''; })() : '') +
          (o.change || o.dupe ? '<span class="trio-line__acts">' + (o.change ? '<button type="button" class="trio-textlink" data-change>' + esc(t('change', 'changer')) + '</button>' : '') + (o.dupe ? '<button type="button" class="trio-textlink" data-dupe>' + esc(t('again', 'la reprendre')) + '</button>' : '') + '</span>' : '') +
          '</div>' +
          (v.available ? '' : '<p class="trio-line__soldout">' + esc(t('soldout_size', 'épuisée dans cette taille')) + '</p>') +
        '</div>' +
      '</div>';
  };

  /* ---- base ---- */
  class TrioBase extends HTMLElement {
    bindLines(root) {
      root.querySelectorAll('[data-slot]').forEach((el) => {
        const slot = this.slots[parseInt(el.dataset.slot, 10)];
        if (!slot) return;
        el.querySelectorAll('[data-variant]').forEach((b) => b.addEventListener('click', () => { slot.variant = slot.product.variants.find((x) => String(x.id) === b.dataset.variant); this.render(); }));
        const ins = el.querySelector('[data-insert]'); if (ins) ins.addEventListener('change', () => { slot.insert = ins.checked; this.repaintPrices(); });
        const chg = el.querySelector('[data-change]'); if (chg) chg.addEventListener('click', () => this.pick(slot.index));
        const dup = el.querySelector('[data-dupe]'); if (dup) dup.addEventListener('click', () => this.dupe(slot.index));
        const rm = el.querySelector('[data-remove]'); if (rm) rm.addEventListener('click', () => this.drop(slot.index));
      });
    }
    drop(index) { this.slots[index] = { index: index }; this.render(); }
    /* cocher un intérieur ne doit pas recharger les photos : on ne réécrit que les prix */
    repaintPrices() {
      const pr = price(this.slots);
      if (this.list) {
        this.list.querySelectorAll('[data-slot]').forEach((el) => {
          const i = parseInt(el.dataset.slot, 10), slot = this.slots[i];
          if (!slot || !slot.product) return;
          const pay = el.querySelector('.trio-line__pay'); if (!pay) return;
          const old = pay.querySelector('.trio-line__price');
          if (old) old.outerHTML = linePrice(slot, pr.free.indexOf(i) !== -1);
          const lab = pay.querySelector('.trio-switch__label'), ins = insertFor(slot.variant.size);
          const on = !!slot.insert && ins && ins.available !== false;
          if (lab && ins) lab.innerHTML = esc(t('with_insert', 'avec son intérieur')) + (on ? '' : '<em>+ ' + esc(money(ins.price)) + '</em>');
        });
      }
      if (this.sum) this.sum.innerHTML = nudgeLine(pr);
      this.ctaTotal(pr);
    }
    /* le montant à payer, posé à droite dans le bouton */
    ctaTotal(pr) {
      if (!this.btn) return;
      let tot = this.btn.querySelector('.trio-btn__total');
      if (pr && pr.n > 0) {
        if (!tot) { tot = document.createElement('b'); tot.className = 'trio-btn__total'; this.btn.appendChild(tot); }
        tot.textContent = money(totalOf(this.slots, pr));
      } else if (tot) { tot.remove(); }
    }
    usedSizes() { return this.slots.filter((s) => s && s.product).map((s) => s.variant.size); }
    /* la même housse, une deuxième fois, dans une autre taille si elle existe */
    dupe(index) {
      const from = this.slots[index]; if (!from || !from.product) return;
      const target = this.slots.findIndex((s) => !s || !s.product);
      if (target === -1) return;
      const p = from.product;
      const used = this.slots.filter((s) => s && s.product && s.product.handle === p.handle).map((s) => s.variant.id);
      const v = p.variants.find((x) => x.available && used.indexOf(x.id) === -1) || from.variant;
      this.slots[target] = { index: target, product: p, variant: v, insert: from.insert };
      this.render();
    }
    items(insertsOn) {
      const items = []; let soldout = null;
      const push = (id) => { const found = items.find((x) => x.id === id); if (found) found.quantity += 1; else items.push({ id: id, quantity: 1 }); };
      this.slots.forEach((s) => {
        if (!s || !s.product) return;
        if (!s.variant.available) { soldout = s.product.short; return; }
        push(s.variant.id);
        const on = typeof s.insert === 'boolean' ? s.insert : insertsOn;
        if (on) { const i = insertFor(s.variant.size); if (i && i.available !== false) push(i.id); }
      });
      return { items, soldout };
    }
    submit(btn, insertsOn) {
      const r = this.items(insertsOn);
      const err = this.querySelector('[data-error]');
      const showErr = (m) => { if (err) { err.textContent = m; err.hidden = false; } };
      if (err) err.hidden = true;
      if (r.soldout) { showErr(t('soldout_in', 'épuisée : ') + r.soldout); return; }
      if (!r.items.length) return;
      btn.classList.add('is-loading'); btn.disabled = true;
      addToCart(r.items).catch((e) => showErr(e.message || 'Erreur')).finally(() => { btn.classList.remove('is-loading'); btn.disabled = false; });
    }
  }

  /* ---- le canapé, à l'échelle (1 unité = 1 cm) ---- */
  /* géométrie à l'échelle : dossier ~58 cm, assise à 24 cm, les housses s'enfoncent de 5 cm dans l'assise
     et même le géant 110x55 reste sous la ligne du dossier. */
  const ARM = 18, SEAT_TOP = 80, SEAT_BOT = 104, BACK_TOP = 35, LEG_H = 18, CUSHION_BASE = 85, ARM_RISE = 26;
  const TILT = [-3, 2, -2, 3, -1, 2];
  /* la couleur du canapé : une seule teinte de base, le reste s'en déduit */
  const SOFA_DEFAULT = '#DED4C6';
  /* les tissus les plus courants d'abord : beige, écru, taupe, café, gris, anthracite, puis les teintes de caractère */
  const SOFA_PALETTE = ['#DED4C6', '#EFE9DF', '#C4B7A6', '#8C7767', '#C9C4BB', '#6F6B66', '#B7C0B2', '#6C7A8C', '#C89C88'];
  const hex2rgb = (h) => { h = String(h).replace('#', ''); if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; const n = parseInt(h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; };
  const rgb2hex = (c) => '#' + c.map((x) => Math.max(0, Math.min(255, Math.round(x))).toString(16).padStart(2, '0')).join('');
  const mix = (h, target, amt) => { const a = hex2rgb(h), b = hex2rgb(target); return rgb2hex([0, 1, 2].map((i) => a[i] + (b[i] - a[i]) * amt)); };
  const isHex = (v) => /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(String(v || ''));
  const sofaTones = (base) => { const b = isHex(base) ? base : SOFA_DEFAULT; return { back: b, seat: mix(b, '#ffffff', 0.16), arm: mix(b, '#000000', 0.06), leg: mix(b, '#3B2E22', 0.45) }; };
  /* cadrage de la photo dans la housse : [zoom, point de mire vertical dans la photo].
     Les grandes descendent plus bas dans l'image, les 30x50 sont un peu plus zoomées.
     Ne sert plus que de secours, pour les housses qui n'ont pas encore de photo détourée. */
  const CROP = { '45x45': [2.9, 0.38], '40x60': [2.2, 0.39], '30x50': [2.7, 0.35], rond: [2.6, 0.34], '110x55': [1.8, 0.33], '55x110': [1.8, 0.33] };
  const cropFor = (key) => CROP[key] || [2.4, 0.38];

  /* ---- housses détourées ----
     trio-cushions donne, pour chaque handle + taille : le fichier et sa taille en cm.
     Le tissu y est déjà à la bonne échelle, donc on pose l'image telle quelle, centrée
     sur la housse : les pompons débordent naturellement du rectangle. */
  const ART = cfg.cushions || {};
  const ART_BASE = cfg.filesBase || 'https://cdn.shopify.com/s/files/1/0895/6723/2323/files/';
  const artFor = (handle, size) => {
    if (!handle || !size) return null;
    return ART[handle + '__' + size] || ART[handle + '__' + String(size).split('x').reverse().join('x')] || null;
  };

  const cushionBox = (v) => {
    const k = (v && v.size) || '45x45';
    if (k === 'rond') return { w: 45, h: 45, round: true };
    const m = k.split('x').map(Number);
    if (m.length !== 2 || !m[0] || !m[1]) return { w: 45, h: 45 };
    return { w: Math.max(m[0], m[1]), h: Math.min(m[0], m[1]) };
  };
  const sofaLayout = (boxes, sofaW) => {
    const n = boxes.length;
    if (!n) return { items: [], over: false };
    const total = boxes.reduce((s, b) => s + b.w, 0);
    const usable = sofaW - 6;
    let ov = 0;
    if (n > 1) {
      const need = total - usable;
      const small = Math.min.apply(null, boxes.map((b) => b.w));
      /* sur un petit canapé on superpose franchement : la grande derrière, la petite devant */
      const cap = small * (n === 2 ? 0.78 : 0.62);
      ov = need > 0 ? need / (n - 1) : Math.min(9, (total * 0.05) / (n - 1));
      ov = Math.max(0, Math.min(ov, cap));
    }
    const width = total - ov * (n - 1);
    let x = ARM + (sofaW - width) / 2;
    const items = boxes.map((b, i) => { const it = { b: b, i: i, x: x }; x += b.w - ov; return it; });
    /* on ne prévient que si ça déborde vraiment au-delà des accoudoirs */
    return { items: items, over: width > sofaW + ARM };
  };
  const sofaSVG = (uid, slots, sofaW, baseColor) => {
    const T = sofaTones(baseColor);
    const W = sofaW + 2 * ARM;
    const filled = slots.filter((s) => s && s.product);
    const boxes = filled.map((s) => { const b = cushionBox(s.variant); b.slot = s; return b; });
    const L = sofaLayout(boxes, sofaW);
    sofaSVG.last = L.items.map((it) => ({ index: it.b.slot.index, mid: it.x + (it.b.slot.dx || 0) + it.b.w / 2 }));
    let defs = '', cushions = '';
    const front = (it) => it.b.slot.front || 0;
    const area = (it) => it.b.w * it.b.h;
    L.items.slice().sort((a, b) => front(a) - front(b) || area(b) - area(a) || b.b.h - a.b.h).forEach((it) => {
      const b = it.b, y = CUSHION_BASE - b.h;
      /* placement libre : le décalage laissé par le glisser-déposer, borné à la vue */
      const x = Math.max(-6, Math.min(W + 6 - b.w, it.x + (b.slot.dx || 0)));
      const cx = x + b.w / 2, cy = y + b.h / 2, id = uid + 'p' + it.i;
      const rx = b.round ? b.w / 2 : 3;
      const open = '<g class="trio-sofa__cushion" data-cushion="' + b.slot.index + '" transform="rotate(' + TILT[it.i % TILT.length] + ' ' + cx + ' ' + cy + ')" role="button" tabindex="0" aria-label="' + esc(b.slot.product.short) + '">';
      /* la zone sensible reste le rectangle de la housse : les pompons et le vide autour ne volent pas le clic */
      const hit = '<rect x="' + x + '" y="' + y + '" width="' + b.w + '" height="' + b.h + '" rx="' + rx + '" fill="#000" fill-opacity="0"></rect>';
      const art = artFor(b.slot.product.handle, b.slot.variant && b.slot.variant.size);
      if (art) {
        const aw = art[1], ah = art[2];
        cushions += open +
          '<image href="' + esc(ART_BASE + art[0]) + '" x="' + (cx - aw / 2) + '" y="' + (cy - ah / 2) + '" width="' + aw + '" height="' + ah + '" preserveAspectRatio="none" style="pointer-events:none"></image>' +
          hit + '</g>';
        return;
      }
      /* secours : pas de photo détourée, on remplit le rectangle avec la photo produit */
      const cf = cropFor(b.slot.variant && b.slot.variant.size);
      const w = b.w * cf[0], h = (w * 4) / 3, ix = (b.w - w) / 2, iy = b.h / 2 - h * cf[1];
      defs += '<pattern id="' + id + '" patternUnits="userSpaceOnUse" x="' + x + '" y="' + y + '" width="' + b.w + '" height="' + b.h + '"><image href="' + esc(swatchFor(b.slot.product)) + '" x="' + ix + '" y="' + iy + '" width="' + w + '" height="' + h + '" preserveAspectRatio="xMidYMid slice"></image></pattern>';
      cushions += open +
        '<rect x="' + x + '" y="' + y + '" width="' + b.w + '" height="' + b.h + '" rx="' + rx + '" fill="url(#' + id + ')"></rect>' +
        '<rect x="' + x + '" y="' + y + '" width="' + b.w + '" height="' + b.h + '" rx="' + rx + '" fill="none" stroke="rgba(28,28,28,.22)" stroke-width=".7"></rect>' +
        '</g>';
    });
    return '<svg class="trio-sofa__svg" viewBox="-6 22 ' + (W + 12) + ' 104" preserveAspectRatio="xMidYMax meet" aria-hidden="true"><defs>' + defs + '</defs>' +
      '<rect x="' + ARM + '" y="' + BACK_TOP + '" width="' + sofaW + '" height="' + (SEAT_TOP - BACK_TOP + 10) + '" rx="10" fill="' + T.back + '"></rect>' +
      '<rect x="0" y="' + SEAT_TOP + '" width="' + W + '" height="' + (SEAT_BOT - SEAT_TOP) + '" rx="10" fill="' + T.seat + '"></rect>' +
      '<rect x="0" y="' + (SEAT_TOP - ARM_RISE) + '" width="' + ARM + '" height="' + (SEAT_BOT - SEAT_TOP + ARM_RISE) + '" rx="9" fill="' + T.arm + '"></rect>' +
      '<rect x="' + (W - ARM) + '" y="' + (SEAT_TOP - ARM_RISE) + '" width="' + ARM + '" height="' + (SEAT_BOT - SEAT_TOP + ARM_RISE) + '" rx="9" fill="' + T.arm + '"></rect>' +
      '<rect x="12" y="' + SEAT_BOT + '" width="9" height="' + LEG_H + '" rx="3" fill="' + T.leg + '"></rect>' +
      '<rect x="' + (W - 21) + '" y="' + SEAT_BOT + '" width="9" height="' + LEG_H + '" rx="3" fill="' + T.leg + '"></rect>' +
      /* au-delà de 200 cm, un vrai canapé a un pied au milieu */
      (sofaW > 200 ? '<rect x="' + (W / 2 - 4.5) + '" y="' + SEAT_BOT + '" width="9" height="' + LEG_H + '" rx="3" fill="' + T.leg + '"></rect>' : '') +
      cushions + '</svg>' + (L.over ? '<p class="trio-sofa__warn">' + esc(t('too_many', 'ça déborde un peu, élargissez le canapé ou retirez une housse')) + '</p>' : '');
  };

  /* ---- Galerie de looks + fiche look ---- */
  class TrioGallery extends TrioBase {
    connectedCallback() {
      this.looks = {};
      this.querySelectorAll('[data-look]').forEach((el) => {
        const data = el.querySelector('[data-products]');
        this.looks[el.dataset.look] = { el, products: data ? JSON.parse(data.textContent).map(normalise) : [] };
      });
      this.querySelectorAll('[data-open-look]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); this.open(b.dataset.openLook); }));
      this.querySelectorAll('[data-close-look]').forEach((b) => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.current) this.close(); });
      this.catalogue = [];
      const hash = (location.hash || '').replace('#look-', '');
      if (hash && this.looks[hash]) setTimeout(() => this.open(hash), 300);
    }
    loadCatalogue() {
      if (this.cataloguePromise) return this.cataloguePromise;
      const url = this.dataset.productsJson;
      if (!url) return (this.cataloguePromise = Promise.resolve([]));
      this.cataloguePromise = fetch(url, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((j) => { this.catalogue = (j.products || []).filter((p) => (p.variants || []).length).map(normalise).filter((p) => p.minPrice >= (cfg.minPrice || 0)); return this.catalogue; })
        .catch(() => []);
      return this.cataloguePromise;
    }
    pick(index) {
      this.loadCatalogue().then((list) => {
        if (!list.length) return;
        const chosen = this.slots.filter((s) => s && s.product).map((s) => s.product.handle);
        getPicker().open(list, (p, v) => { this.slots[index] = { index: index, product: p, variant: v }; this.render(); }, chosen, this.usedSizes());
      });
    }
    seed() {
      const detail = this.slots.filter((s) => s && s.product).map((s) => ({ handle: s.product.handle, variantId: s.variant.id }));
      this.close();
      document.dispatchEvent(new CustomEvent('trio:seed', { detail: detail }));
    }
    open(handle) {
      const look = this.looks[handle]; if (!look) return;
      this.current = look;
      /* l'ordre et les tailles sont ceux de la photo */
      this.insertsOn = this.dataset.insertsDefault !== 'false';
      this.slots = look.products.slice(0, 6).map((p, i) => ({ index: i, product: p, variant: firstAvailable(p), insert: this.insertsOn }));
      this.list = look.el.querySelector('[data-lines]');
      this.sum = look.el.querySelector('[data-priceline]');
      this.btn = look.el.querySelector('[data-add]');
      this.sw = look.el.querySelector('[data-inserts-switch]');
      if (this.sw) { this.sw.checked = this.insertsOn; this.sw.onchange = () => { this.insertsOn = this.sw.checked; this.slots.forEach((s) => { if (s && s.product) s.insert = this.insertsOn; }); this.render(); }; }
      if (this.btn) this.btn.onclick = () => this.submit(this.btn, this.insertsOn);
      const seedBtn = look.el.querySelector('[data-seed]');
      if (seedBtn) seedBtn.onclick = () => this.seed();
      this.loadCatalogue();
      this.render();
      look.el.classList.add('is-open'); lockScroll();
      /* le thème remplace src par data-src : on force le chargement à l'ouverture */
      look.el.querySelectorAll('img[data-src]').forEach((im) => {
        if (!im.getAttribute('src') || im.getAttribute('src') !== im.dataset.src) im.src = im.dataset.src;
        im.classList.remove('lazyHide');
      });
      look.el.querySelector('.trio-lsheet__scroll').scrollTop = 0;
      history.replaceState(null, '', '#look-' + handle);
    }
    close() {
      if (!this.current) return;
      this.current.el.classList.remove('is-open'); unlockScroll();
      this.current = null;
      history.replaceState(null, '', location.pathname + location.search);
    }
    render() {
      if (!this.list) return;
      const pr = price(this.slots);
      this.list.innerHTML = this.slots.map((s, i) => lineHTML(s, { change: true, perInsert: true, free: pr.free.indexOf(i) !== -1 })).join('');
      this.sum.innerHTML = nudgeLine(pr);
      this.ctaTotal(pr);
      this.bindLines(this.list);
    }
  }

  /* ---- panneau de choix ---- */
  class TrioPicker {
    constructor() {
      this.el = document.createElement('div');
      this.el.className = 'trio-sheet trio-picker';
      this.el.innerHTML = '' +
        '<div class="trio-sheet__backdrop" data-close></div>' +
        '<div class="trio-sheet__panel" role="dialog" aria-modal="true" aria-label="' + esc(t('pick', 'choisir une housse')) + '">' +
          '<div class="trio-sheet__head"><div class="trio-sheet__title" data-title>' + esc(t('pick', 'choisir une housse')) + '</div><button type="button" class="trio-sheet__close" data-close aria-label="' + esc(t('close', 'fermer')) + '">×</button></div>' +
          '<div class="trio-sheet__filters" data-filters></div>' +
          '<div class="trio-sheet__scroll"><div class="trio-grid" data-grid></div></div>' +
          '<div class="trio-sheet__detail" data-detail hidden></div>' +
        '</div>';
      document.body.appendChild(this.el);
      this.el.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) this.close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.el.classList.contains('is-open')) this.close(); });
      this.filter = 'all';
    }
    open(products, onPick, chosen, usedSizes) {
      this.products = products; this.onPick = onPick; this.filter = 'all';
      this.chosen = chosen || []; this.usedSizes = usedSizes || [];
      this.el.querySelector('[data-title]').textContent = t('pick', 'choisir une housse');
      this.renderFilters(); this.renderGrid(); this.hideDetail();
      this.el.classList.add('is-open'); lockScroll();
      this.el.querySelector('.trio-sheet__scroll').scrollTop = 0;
    }
    close() { if (!this.el.classList.contains('is-open')) return; this.hideDetail(); this.el.classList.remove('is-open'); unlockScroll(); }
    families() { return cfg.families || [{ key: 'all', label: t('filter_all', 'toutes'), tags: [] }]; }
    renderFilters() {
      const wrap = this.el.querySelector('[data-filters]');
      wrap.innerHTML = this.families().map((f) => '<button type="button" class="trio-chip' + (f.key === this.filter ? ' is-on' : '') + '" data-filter="' + f.key + '">' + esc(f.label) + '</button>').join('');
      wrap.querySelectorAll('[data-filter]').forEach((b) => b.addEventListener('click', () => {
        this.filter = b.dataset.filter;
        this.hideDetail(); /* on revient à la liste : changer de famille, c'est repartir du début */
        this.renderFilters(); this.renderGrid();
        this.el.querySelector('.trio-sheet__scroll').scrollTop = 0;
      }));
    }
    renderGrid() {
      const fam = this.families().find((f) => f.key === this.filter);
      const list = this.products.filter((p) => {
        if (!fam) return true;
        /* famille de forme : on regarde la taille des variantes */
        if (fam.sizes && fam.sizes.length) return p.variants.some((v) => fam.sizes.indexOf(v.size) !== -1);
        if (!fam.tags.length) return true;
        return p.tags.some((tg) => fam.tags.indexOf(String(tg).toLowerCase()) !== -1);
      });
      const grid = this.el.querySelector('[data-grid]');
      grid.innerHTML = list.map((p) => {
        const inTrio = (this.chosen || []).indexOf(p.handle) !== -1;
        const live = p.variants.some((v) => v.available);
        /* on montre toutes les tailles, épuisées comprises : la photo reste lisible */
        const sizes = p.variants.map((v) => sizeLabel(v.size).replace(' cm', '')).filter((x, i, a) => a.indexOf(x) === i).join(' · ');
        return '<button type="button" class="trio-tile' + (live ? '' : ' is-off') + (inTrio ? ' is-chosen' : '') + '" data-handle="' + esc(p.handle) + '">' +
          '<span class="trio-tile__img"><img src="' + esc(img(p.image, 360)) + '" alt="" loading="lazy">' +
          (inTrio ? '<span class="trio-tile__badge">' + esc(t('again_badge', 'déjà dans le trio')) + '</span>' : '') +
          (live ? '' : '<span class="trio-tile__badge trio-tile__badge--off">' + esc(t('soldout', 'épuisée')) + '</span>') + '</span>' +
          '<span class="trio-tile__name">' + esc(p.short) + '</span>' +
          '<span class="trio-tile__meta">' + esc(sizes) + '</span>' +
          '</button>';
      }).join('') || '<p class="trio-empty">' + esc(t('none', 'rien dans cette famille pour le moment')) + '</p>';
      grid.querySelectorAll('[data-handle]').forEach((b) => b.addEventListener('click', () => this.showDetail(this.products.find((p) => p.handle === b.dataset.handle))));
    }
    showDetail(p) {
      const d = this.el.querySelector('[data-detail]');
      let v = varyVariant(p, this.usedSizes);
      const render = () => {
        d.innerHTML = '' +
          '<div class="trio-detail">' +
            '<button type="button" class="trio-textlink" data-back>← ' + esc(t('back', 'retour')) + '</button>' +
            (function () {
              /* comme une fiche produit : la photo entière, jamais recadrée, et toutes les autres en vignettes */
              var gal = (p.images && p.images.length ? p.images : [p.image]).filter(Boolean).slice(0, 10);
              return '<div class="trio-detail__media">' +
                '<div class="trio-detail__main"><img src="' + esc(img(gal[0], 1000)) + '" alt="" data-main></div>' +
                (gal.length > 1 ? '<div class="trio-detail__thumbs">' + gal.map(function (u, k) {
                  return '<button type="button" class="trio-detail__thumb' + (k ? '' : ' is-on') + '" data-photo="' + esc(img(u, 1000)) + '"><img src="' + esc(img(u, 320)) + '" alt="" loading="lazy"></button>';
                }).join('') + '</div>' : '') +
              '</div>';
            })() +
            '<div class="trio-detail__name">' + esc(p.short) + '</div>' +
            (p.hasOptions
              ? '<div class="trio-seg trio-seg--lg" role="radiogroup">' + p.variants.map((x) => '<button type="button" class="trio-seg__btn' + (x.id === v.id ? ' is-on' : '') + (x.available ? '' : ' is-off') + '" data-variant="' + x.id + '">' + esc(optLabel(x.title)) + '</button>').join('') + '</div>' + (!sizeKey(v.title) && v.size ? '<div class="trio-detail__size">' + esc(sizeLabel(v.size)) + '</div>' : '')
              : '<div class="trio-detail__size">' + esc(sizeLabel(v.size)) + '</div>') +
            '<div class="trio-detail__price">' + money(v.price) + '</div>' +
            '<button type="button" class="trio-btn" data-choose ' + (v.available ? '' : 'disabled') + '>' + (v.available ? esc(t('choose', 'choisir cette housse')) : esc(t('soldout', 'épuisée'))) + '</button>' +
            '<a class="trio-textlink" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(t('see_product', 'voir la housse en détail')) + '</a>' +
          '</div>';
        d.querySelector('[data-back]').addEventListener('click', () => this.hideDetail());
        d.querySelectorAll('[data-photo]').forEach((b) => b.addEventListener('click', () => {
          const main = d.querySelector('[data-main]');
          if (main) main.src = b.dataset.photo;
          d.querySelectorAll('[data-photo]').forEach((x) => x.classList.remove('is-on'));
          b.classList.add('is-on');
        }));
        d.querySelectorAll('[data-variant]').forEach((b) => b.addEventListener('click', () => { v = p.variants.find((x) => String(x.id) === b.dataset.variant); render(); }));
        d.querySelector('[data-choose]').addEventListener('click', () => { this.onPick(p, v); this.close(); });
      };
      render();
      d.hidden = false; this.el.querySelector('.trio-sheet__scroll').hidden = true; this.el.querySelector('[data-filters]').hidden = true;
    }
    hideDetail() { this.el.querySelector('[data-detail]').hidden = true; this.el.querySelector('.trio-sheet__scroll').hidden = false; this.el.querySelector('[data-filters]').hidden = false; }
  }
  let picker = null;
  const getPicker = () => (picker = picker || new TrioPicker());

  /* ---- le composeur : un canapé à l'échelle, autant de housses qu'on veut ---- */
  const MIN_SLOTS = 3, MAX_SLOTS = 6;
  /* plus le canapé est large, plus il en faut : 1 place 2, 2 places 3, 3 places 4, puis 5 et 6 */
  class TrioBuilder extends TrioBase {
    connectedCallback() {
      this.uid = 'tb' + Math.random().toString(36).slice(2, 7);
      this.slots = [{ index: 0 }, { index: 1 }, { index: 2 }];
      this.products = [];
      this.stage = this.querySelector('[data-sofa]');
      this.list = this.querySelector('[data-lines]');
      this.sum = this.querySelector('[data-priceline]');
      this.btn = this.querySelector('[data-add]');
      this.range = this.querySelector('[data-sofa-range]');
      this.value = this.querySelector('[data-sofa-value]');
      this.presets = this.querySelector('[data-sofa-presets]');
      this.paint = this.querySelector('[data-sofa-paint]');
      this.sofaColor = this.storedColor() || SOFA_DEFAULT;
      this.buildPaint();
      const lab = this.querySelector('[data-sofa-label]');
      if (lab) lab.textContent = t('sofa', 'votre canapé');
      const min = parseInt(this.dataset.sofaMin, 10) || 60;
      const max = parseInt(this.dataset.sofaMax, 10) || 300;
      this.sofaW = this.stored() || parseInt(this.dataset.sofaDefault, 10) || 200;
      this.sofaW = Math.max(min, Math.min(max, this.sofaW));
      if (this.range) {
        this.range.min = min; this.range.max = max; this.range.value = this.sofaW;
        this.range.addEventListener('input', () => { this.sofaW = parseInt(this.range.value, 10); this.store(); if (this.fit()) this.render(); else this.paintSofa(); });
      }
      if (this.presets) {
        const P = [[60, t('preset_1', 'fauteuil')], [140, t('preset_2', '2 places')], [200, t('preset_3', '3 places')], [280, t('preset_4', 'banquette')]];
        this.presets.innerHTML = P.filter((p) => p[0] >= min && p[0] <= max).map((p) => '<button type="button" class="trio-chip" data-w="' + p[0] + '">' + esc(p[1]) + '</button>').join('');
        this.presets.querySelectorAll('[data-w]').forEach((b) => b.addEventListener('click', () => {
          this.sofaW = parseInt(b.dataset.w, 10); if (this.range) this.range.value = this.sofaW; this.store();
          if (this.fit()) this.render(); else this.paintSofa();
        }));
      }
      if (this.btn) this.btn.addEventListener('click', () => this.submit(this.btn, true));
      this.frontSeq = 0;
      this.fit();
      this.render();
      fetch(this.dataset.productsJson, { headers: { 'Accept': 'application/json' } }).then((r) => r.json()).then((j) => {
        this.products = (j.products || []).filter((p) => (p.variants || []).length).map(normalise).filter((p) => p.minPrice >= (cfg.minPrice || 0));
        this.classList.add('is-ready');
        const pre = new URLSearchParams(location.search).get('trio');
        if (pre) this.seed(pre.split(',').map((h) => ({ handle: h })));
        if (this.pending) { const s = this.pending; this.pending = null; this.seed(s); }
        this.render();
      }).catch((e) => console.error(e));
      /* « partir de ce trio » depuis une fiche look */
      document.addEventListener('trio:seed', (e) => {
        if (!this.products.length) { this.pending = e.detail; }
        else { this.seed(e.detail); this.render(); }
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    stored() { try { return parseInt(localStorage.getItem('kirane:sofa'), 10) || 0; } catch (e) { return 0; } }
    storedColor() { try { const v = localStorage.getItem('kirane:sofaColor'); return isHex(v) ? v : ''; } catch (e) { return ''; } }
    storeColor() { try { localStorage.setItem('kirane:sofaColor', this.sofaColor); } catch (e) { /* navigation privée */ } }
    /* la teinte du canapé : sept tissus, et une pipette pour tout le reste */
    buildPaint() {
      if (!this.paint) return;
      this.paint.innerHTML = '<span class="trio-paint__label">' + esc(t('sofa_color', 'la couleur de mon canapé')) + '</span>' + SOFA_PALETTE.map((c) => '<button type="button" class="trio-paint__dot" data-tone="' + c + '" style="background:' + c + '" aria-label="' + esc(t('sofa_color', 'couleur du canapé')) + '"></button>').join('') +
        '<label class="trio-paint__pick" title="' + esc(t('sofa_color_custom', 'une autre couleur')) + '"><input type="color" data-tone-input value="' + this.sofaColor + '" aria-label="' + esc(t('sofa_color_custom', 'une autre couleur')) + '"><span aria-hidden="true">◍</span></label>';
      this.paint.querySelectorAll('[data-tone]').forEach((b) => b.addEventListener('click', () => this.setTone(b.dataset.tone)));
      this.toneInput = this.paint.querySelector('[data-tone-input]');
      if (this.toneInput) this.toneInput.addEventListener('input', () => this.setTone(this.toneInput.value));
      this.markTone();
    }
    markTone() {
      if (!this.paint) return;
      this.paint.querySelectorAll('[data-tone]').forEach((b) => b.classList.toggle('is-on', b.dataset.tone.toLowerCase() === String(this.sofaColor).toLowerCase()));
    }
    setTone(c) {
      if (!isHex(c)) return;
      this.sofaColor = c; this.storeColor(); this.markTone();
      if (this.toneInput && this.toneInput.value.toLowerCase() !== c.toLowerCase()) this.toneInput.value = c;
      this.paintSofa();
    }
    store() { try { localStorage.setItem('kirane:sofa', String(this.sofaW)); } catch (e) { /* navigation privée */ } }
    /* remplit le canapé à partir d'une proposition, modifiable ensuite */
    seed(list) {
      const src = (list || []).slice(0, MAX_SLOTS);
      if (!src.length) return;
      this.slots = [];
      src.forEach((entry, i) => {
        const p = this.products.find((x) => x.handle === entry.handle);
        if (!p) { this.slots.push({ index: i }); return; }
        const v = (entry.variantId && p.variants.find((x) => String(x.id) === String(entry.variantId))) || firstAvailable(p);
        this.slots.push({ index: i, product: p, variant: v, insert: this.dataset.insertsDefault !== 'false' });
      });
      while (this.slots.length < MIN_SLOTS) this.slots.push({ index: this.slots.length });
      this.fit();
    }
    add() { if (this.slots.length < MAX_SLOTS) { this.slots.push({ index: this.slots.length }); this.render(); } }
    /* la largeur du canapé n'impose rien : on garde juste le minimum de places */
    fit() {
      let changed = false;
      while (this.slots.length < MIN_SLOTS) { this.slots.push({ index: this.slots.length }); changed = true; }
      this.slots.forEach((s, i) => { s.index = i; });
      return changed;
    }
    /* glisser une housse pour la déplacer sur le canapé */
    move(from, to) {
      if (from === to || from < 0 || to < 0) return;
      const moved = this.slots.splice(from, 1)[0];
      this.slots.splice(to, 0, moved);
      this.slots.forEach((s, i) => { s.index = i; });
      this.render();
    }
    bindSofa() {
      const svg = this.stage && this.stage.querySelector('svg');
      if (!svg) return;
      const vb = svg.viewBox.baseVal;
      const ux = (e) => { const r = svg.getBoundingClientRect(); return vb.x + ((e.clientX - r.left) / r.width) * vb.width; };
      let drag = null;
      svg.querySelectorAll('[data-cushion]').forEach((g) => {
        const idx = parseInt(g.dataset.cushion, 10);
        const base = g.getAttribute('transform') || '';
        g.addEventListener('pointerdown', (e) => {
          drag = { g: g, idx: idx, x0: ux(e), moved: 0 };
          try { g.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
          /* appui long : la housse passe devant les autres */
          drag.timer = setTimeout(() => {
            if (!drag || drag.moved > 3) return;
            const slot = this.slots[idx];
            if (slot) { slot.front = ++this.frontSeq; this.paintSofa(); drag = null; }
          }, 420);
        });
        g.addEventListener('pointermove', (e) => {
          if (!drag || drag.g !== g) return;
          const dx = ux(e) - drag.x0;
          drag.lastX = ux(e);
          drag.moved = Math.max(drag.moved, Math.abs(dx));
          if (drag.moved > 3) { clearTimeout(drag.timer); g.classList.add('is-dragging'); }
          g.setAttribute('transform', 'translate(' + dx + ' 0) ' + base);
        });
        const end = (e) => {
          if (!drag || drag.g !== g) return;
          clearTimeout(drag.timer);
          /* sur mobile le pointerup n'a pas toujours de coordonnée fiable : on garde la dernière du déplacement */
          const d = drag, x = (typeof d.lastX === 'number' ? d.lastX : ux(e));
          drag = null;
          g.classList.remove('is-dragging');
          if (d.moved <= 3) { this.pick(d.idx); return; }
          /* placement 100 % libre : on garde le décalage, on ne réordonne pas */
          const slot = this.slots[d.idx];
          if (slot) { slot.dx = (slot.dx || 0) + (x - d.x0); slot.front = ++this.frontSeq; }
          this.paintSofa();
        };
        g.addEventListener('pointerup', end);
        g.addEventListener('pointercancel', end);
      });
    }
    drop(index) {
      if (this.slots.length > MIN_SLOTS) this.slots.splice(index, 1);
      else this.slots[index] = { index: index };
      this.slots.forEach((s, i) => { s.index = i; });
      this.render();
    }
    pick(index) {
      if (!this.products.length) return;
      const chosen = this.slots.filter((s) => s && s.product).map((s) => s.product.handle);
      getPicker().open(this.products, (p, v) => {
        this.slots[index] = { index: index, product: p, variant: v, insert: this.dataset.insertsDefault !== 'false' };
        this.render();
      }, chosen, this.usedSizes());
    }
    paintSofa() {
      if (this.stage) this.stage.innerHTML = sofaSVG(this.uid, this.slots, this.sofaW, this.sofaColor);
      if (this.value) this.value.textContent = this.sofaW + ' cm';
      if (this.presets) this.presets.querySelectorAll('[data-w]').forEach((b) => b.classList.toggle('is-on', parseInt(b.dataset.w, 10) === this.sofaW));
      this.bindSofa();
      const svg = this.stage && this.stage.querySelector('svg');
      if (svg) svg.addEventListener('click', (e) => { if (!e.target.closest('.trio-sofa__cushion') && this.toneInput) this.toneInput.click(); });
    }
    render() {
      this.paintSofa();
      const pr = price(this.slots);
      const empty = this.slots.some((s) => !s || !s.product);
      this.list.innerHTML = this.slots.map((s, i) => (s.product
        ? lineHTML(s, { removable: true, perInsert: true, change: true, dupe: empty, free: pr.free.indexOf(i) !== -1 })
        : '<button type="button" class="trio-slot" data-pick="' + s.index + '" ' + (this.products.length ? '' : 'disabled') + '>' +
            '<span class="trio-slot__plus" aria-hidden="true">+</span>' +
            '<span class="trio-slot__text"><strong>' + esc(t('pick', 'choisir une housse')) + '</strong><em>' + esc(t('vary', 'variez les tailles et les motifs')) + '</em></span>' +
          '</button>')).join('') +
        (this.slots.length < MAX_SLOTS ? '<button type="button" class="trio-textlink trio-add" data-add-slot>+ ' + esc(t('add_cover', 'ajouter une housse')) + '</button>' : '');
      this.sum.innerHTML = nudgeLine(pr);
      this.bindLines(this.list);
      this.list.querySelectorAll('[data-pick]').forEach((b) => b.addEventListener('click', () => this.pick(parseInt(b.dataset.pick, 10))));
      const addBtn = this.list.querySelector('[data-add-slot]');
      if (addBtn) addBtn.addEventListener('click', () => this.add());
      if (this.btn) {
        this.btn.disabled = pr.n === 0;
        this.ctaTotal(pr);
        this.btn.querySelector('span').textContent = pr.n === 0
          ? t('start_trio', 'choisissez votre première housse')
          : pr.n === 3 ? t('add_trio', 'ajouter le trio au panier')
          : fill(t('add_n', 'ajouter {n} housse(s) au panier'), { n: pr.n }).replace('(s)', pr.n > 1 ? 's' : '');
      }
    }
  }

  if (!customElements.get('trio-gallery')) customElements.define('trio-gallery', TrioGallery);
  if (!customElements.get('trio-builder')) customElements.define('trio-builder', TrioBuilder);
})();